import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { Button, Box, Grid } from '@mui/material'
import FormTextField from './FormTextField'
import Alert from '@mui/material/Alert'
import AgsArchiveButton from '../AgsArchiveButton'

// Define validation schema with
const validationSchema = Yup.object({
  visio_link: Yup.string()
    .nullable()
    .test('is-url-or-required', "L'URL doit être définie ou une URL valide", function (value) {
      const { createError, path } = this
      // Check if the value is null or empty
      if (value === null || value.trim() === '') {
        return createError({ path, message: "L'URL doit être définie." })
      }
      // Check if the value matches the URL format
      if (!/^https?:\/\//.test(value)) {
        return createError({ path, message: "L'URL doit être une URL valide." })
      }

      return true
    }),
  visio_call: Yup.string().nullable(),
  visio_helper: Yup.string().nullable(),
})

const FormConfigVisio = ({ record, onSubmit, isError, message, onArchive }) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  useEffect(() => {
    reset(record) // Reset the form with initialData when it changes
  }, [record, reset])

  const onSubmitForm = (data) => {
    onSubmit(data, reset)
  }
  return (
    <form onSubmit={handleSubmit(onSubmitForm)} style={{ padding: '20px' }}>
      {message && (
        <Box mb={2}>
          <Alert severity={isError ? 'error' : 'success'}>{message}</Alert>
        </Box>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormTextField name="visio_link" control={control} label="Lien Visio" error={errors.visio_link} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormTextField
            name="visio_call"
            control={control}
            label="Infos Conference Call si applicable"
            error={errors.visio_call}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormTextField
            name="visio_helper"
            control={control}
            label="Indications complémentaires Visio"
            error={errors.visio_helper}
          />
        </Grid>
      </Grid>

      <Box mt={2}>
        <Button color="primary" variant="contained" type="submit" disabled={!isDirty} sx={{ mr: 2 }}>
          Enregistrer
        </Button>
        <AgsArchiveButton record={record} onArchive={onArchive} />
      </Box>
    </form>
  )
}

export default FormConfigVisio
